// import Prism from 'prismjs';
// import Prism from '../libs/prism.js';
// import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.js';
// import 'prismjs/plugins/toolbar/prism-toolbar.js';
// import ClipboardJS from 'clipboard';

// Normalize whitespace in code samples
Prism.plugins.NormalizeWhitespace.setDefaults({
  'remove-trailing': true,
  'remove-indent': true,
  'remove-initial-line-feed': true,
  'tabs-to-spaces': 2,
});

